<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal -mt-2">
      <div class="mb-10">
        <div class="flex w-full items-center">
          <div @click="goBack" class="cursor-pointer">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div
            class="text-2xl w-full text-root-2 font-bold flex justify-center"
            test-id="usdcWallet"
          >
            USDC Wallet
          </div>
        </div>
      </div>
      <div class="flex pb-4 justify-center">Copy Wallet Address</div>
      <div class="flex justify-center">
        <div
          class="flex w-3/5 text-root-4 border-text-root-3 py-2 rounded-2xl justify-center cursor-pointer"
        >
          {{ maskWalletAddress(walletAddress) }}
          <span
            class="ml-4"
            v-clipboard:copy="walletAddress"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </span>
        </div>
      </div>
      <div class="my-5 text-center text-base font-semibold text-primary">
        Or
      </div>
      <div class="flex justify-center my-8">
        <qrcode-vue :value="value" :size="size" level="H" />
      </div>
      <div class="my-6 text-center text-base text-primary">Scan QR Code</div>
    </div>
  </el-dialog>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { MaskWalletAddress } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    walletAddress: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      value: this.walletAddress,
      size: 200
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    maskWalletAddress (walletAddress) {
      return MaskWalletAddress(walletAddress)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Wallet Address Copied'
      })
    },
    goBack () {
      this.$emit('goBack')
      this.$emit('closeDialog')
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    QrcodeVue
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
